import { render, staticRenderFns } from "./register-modal.vue?vue&type=template&id=7ccb412c&"
import script from "./register-modal.vue?vue&type=script&lang=js&"
export * from "./register-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ccb412c')) {
      api.createRecord('7ccb412c', component.options)
    } else {
      api.reload('7ccb412c', component.options)
    }
    module.hot.accept("./register-modal.vue?vue&type=template&id=7ccb412c&", function () {
      api.rerender('7ccb412c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/register-modal.vue"
export default component.exports